var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.9,0,16,0z M23.4,23.1c-0.3,0.5-0.9,0.6-1.4,0.3 c-3.8-2.3-8.5-2.8-14.1-1.5c-0.6,0.2-1-0.2-1.2-0.7c-0.2-0.6,0.2-1,0.7-1.2c6.1-1.4,11.4-0.8,15.5,1.8C23.5,22,23.6,22.6,23.4,23.1z  M25.3,18.7c-0.4,0.6-1.1,0.8-1.7,0.4c-4.3-2.6-10.9-3.4-15.9-1.8c-0.6,0.2-1.4-0.2-1.5-0.8C6,15.8,6.3,15.1,7,15 c5.8-1.8,13-0.9,18,2.2C25.4,17.4,25.7,18.2,25.3,18.7z M25.4,14.2c-5.1-3-13.7-3.4-18.6-1.8c-0.8,0.2-1.6-0.2-1.8-1 c-0.2-0.8,0.2-1.6,1-1.8c5.7-1.7,15-1.4,21,2.2c0.7,0.4,1,1.4,0.6,2.1C27.1,14.4,26.2,14.6,25.4,14.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.7ef9a9054e21f4664f49fa5b4219e005.svg";
export { ForwardRef as ReactComponent };